import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { FieldType, FieldTypeConfig, FormlyModule } from '@ngx-formly/core';
import { NzCheckboxModule } from 'ng-zorro-antd/checkbox';
import { NzFormModule } from 'ng-zorro-antd/form';
import { Observable } from 'rxjs';

@Component({
  selector: 'lib-formly-multi-checkbox',
  imports: [
    FormlyModule,
    NzFormModule,
    ReactiveFormsModule,
    CommonModule,
    NzCheckboxModule,
  ],
  templateUrl: './formly-multi-checkbox.component.html',
  styleUrl: './formly-multi-checkbox.component.scss',
})
export class FormlyMultiCheckboxComponent extends FieldType<FieldTypeConfig> {
  get checkboxOptions() {
    const selectedValues = this.formControl.value || [];
    if (this.to.options instanceof Observable) {
      let opts: any[] = [];
      this.to.options.subscribe((arr) => (opts = arr));
      return (opts || []).map((opt) => ({
        label: opt.label,
        value: opt.value,
        disabled: opt.disabled,
        checked: selectedValues.includes(opt.value),
      }));
    }

    return (this.to.options || []).map((opt) => ({
      label: opt.label,
      value: opt.value,
      disabled: opt.disabled,
      checked: selectedValues.includes(opt.value),
    }));
  }

  get errorState() {
    return this.showError ? 'error' : '';
  }
}
